import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'property-form-text',
  templateUrl: './text.component.html',
  imports: [FormlyModule, ReactiveFormsModule],
})
export class TextComponent extends FieldType<FieldTypeConfig> {}
